export const OPEN_BOOKMARK_STATUS = 'open bookmark status';
export const BOOKMARK_STATUS_DOWNLOADED = 'bookmark status downloaded';
export const BOOKMARK_COUNT_DOWNLOADED = 'bookmark count downloaded';
export const POST_BOOKMARK = 'post bookmark';
export const BOOKMARK_POSTED = 'bookmark posted';
export const POST_BOOKMARK_ERROR = 'post bookmark error';

import {postBookmark as apiPostBookmark} from '../modules/apiWrapper.js';
import {getBookmarksByIdentifier} from '../helpers/api.js';
import {getInState} from '../helpers/composeReducer.js';

export function postBookmark(bookmarkData){
    return function(dispatch, getState){
        dispatch({
            type : POST_BOOKMARK,
            bookmarkData
        });
        const partner = getInState(getState,'options.partner_name','');
        let logger    = getInState(getState,'helpers.logger');

        apiPostBookmark(bookmarkData, partner, '', logger).then(function(bookmarkResult){
            dispatch({
                type : BOOKMARK_POSTED,
                bookmarkData : {
                    ...bookmarkData,
                    ...bookmarkResult
                }
            });
        }, function(error){
            dispatch({
                type : POST_BOOKMARK_ERROR,
                error
            });
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/bookmark.action.js